import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FriendsExpertsComponent } from './friends-experts.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.friendsExperts.pageInRouting,
    data: { data: PAGES_AND_PATHS.friendsExperts },
    component: FriendsExpertsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./friends-experts.module').then(m => m.FriendsExpertsModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FriendsExpertsRoutingModule { }
